/**
 * Semaine ISO 8601 en UTC (`2026-W41`), du lundi 00:00 UTC au dimanche
 * 23:59 UTC : la référence des classements hebdomadaires (48 du TODO). Miroir
 * de `server/src/daily/week.js`, vérifié par `tests/weekUtils.test.js`.
 */
export function isoWeek(ms = Date.now()) {
	const d = new Date(ms);
	const day = d.getUTCDay() || 7;
	// Le jeudi de la semaine donne son année ISO.
	const thursday = Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate() + 4 - day);
	const year = new Date(thursday).getUTCFullYear();
	const week = Math.floor((thursday - Date.UTC(year, 0, 1)) / 86400000 / 7) + 1;
	return `${year}-W${String(week).padStart(2, "0")}`;
}

/** Millisecondes jusqu'au lundi 00:00 UTC suivant (fin de la semaine du classement). */
export function msUntilWeekEnd(ms = Date.now()) {
	const d = new Date(ms);
	const day = d.getUTCDay() || 7;
	return Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate() + 8 - day) - ms;
}
